import React from 'react';
import {Dummy} from '../'

export default class TeploAll extends Dummy {

    paintCanvas(cvs) {
        var canvas = document.getElementById(cvs);
        if (canvas.getContext) {
            var ctx = canvas.getContext('2d');

            ctx.fillStyle = "rgba(156, 138, 209, 1)";
            ctx.fillRect(0, 0, 1100, 750);

            ctx.fillStyle = "black";
            ctx.font = "bold 18px Arial";
            ctx.fillText("Узел электрического нагрева ВЕНА-150-А-0-2Р-ЕТ-У-М1", 279, 116);

            ctx.lineWidth = 1;

            ctx.setLineDash([8]);
            ctx.strokeRect(15, 85, 1075, 515);


            ctx.beginPath();//grey dash line
            ctx.strokeStyle = "#696969";
            ctx.setLineDash([8]);
            ctx.moveTo(137, 43);
            ctx.lineTo(754, 43);
            ctx.stroke();
            ctx.moveTo(445, 43);
            ctx.lineTo(445, 136);
            ctx.lineTo(974, 136);
            ctx.stroke();
            ctx.moveTo(445, 136);
            ctx.lineTo(445, 169);
            ctx.lineTo(100, 169);
            ctx.stroke();
            ctx.moveTo(100, 148);
            ctx.lineTo(100, 196);
            ctx.stroke();
            ctx.moveTo(162, 169);
            ctx.lineTo(162, 196);
            ctx.stroke();
            ctx.moveTo(246, 169);
            ctx.lineTo(246, 477);
            ctx.lineTo(204, 477);
            ctx.lineTo(204, 484);
            ctx.stroke();
            ctx.moveTo(445, 169);
            ctx.lineTo(445, 200);
            ctx.stroke();
            ctx.moveTo(433, 235);
            ctx.lineTo(433, 463);
            ctx.lineTo(383, 463);
            ctx.stroke();
            ctx.moveTo(433, 261);
            ctx.lineTo(426, 261);
            ctx.stroke();
            ctx.moveTo(383, 442);
            ctx.lineTo(383, 484);
            ctx.stroke();
            ctx.moveTo(433, 423);
            ctx.lineTo(450, 423);
            ctx.stroke();
            ctx.moveTo(529, 248);
            ctx.lineTo(529, 226);
            ctx.lineTo(660, 226);
            ctx.lineTo(660, 436);
            ctx.stroke();
            ctx.moveTo(573, 429);
            ctx.lineTo(621, 429);
            ctx.lineTo(621, 436);
            ctx.stroke();
            ctx.moveTo(640, 412);
            ctx.lineTo(640, 436);
            ctx.stroke();
            ctx.closePath();

            ctx.beginPath();//red line
            ctx.strokeStyle = "red";
            ctx.setLineDash([]);
            ctx.moveTo(53, 320);
            ctx.lineTo(53, 250);
            ctx.lineTo(100, 250);
            ctx.stroke();
            ctx.moveTo(100, 269);
            ctx.lineTo(100, 232);
            ctx.lineTo(162, 232);
            ctx.lineTo(162, 269);
            ctx.stroke();
            ctx.moveTo(162, 250);
            ctx.lineTo(209, 250);
            ctx.lineTo(209, 320);
            ctx.stroke();
            ctx.moveTo(131, 232);
            ctx.lineTo(131, 185);
            ctx.lineTo(379, 185);
            ctx.stroke();
            ctx.moveTo(401, 185);
            ctx.lineTo(699, 185);
            ctx.stroke();
            ctx.moveTo(719, 185);
            ctx.lineTo(876, 186);
            ctx.lineTo(876, 492);
            ctx.lineTo(900, 492);
            ctx.stroke();
            ctx.moveTo(920, 492);
            ctx.lineTo(951, 492);
            ctx.stroke();
            ctx.moveTo(326, 410);
            ctx.lineTo(326, 404);
            ctx.lineTo(382, 404);
            ctx.lineTo(438, 404);
            ctx.stroke();
            ctx.moveTo(478, 404);
            ctx.lineTo(614, 404);
            ctx.stroke();
            ctx.moveTo(654, 404);
            ctx.lineTo(703, 404);
            ctx.stroke();
            ctx.moveTo(723, 404);
            ctx.lineTo(800, 404);
            ctx.stroke();
            ctx.closePath();

            ctx.fillStyle = "red";
            ctx.beginPath();
            ctx.moveTo(820, 190);
            ctx.lineTo(820, 180);
            ctx.lineTo(828, 185);
            ctx.lineTo(820, 190);
            ctx.fill();
            ctx.moveTo(350, 409);
            ctx.lineTo(350, 399);
            ctx.lineTo(358, 404);
            ctx.lineTo(350, 409);
            ctx.fill();
            ctx.moveTo(765, 409);
            ctx.lineTo(765, 399);
            ctx.lineTo(773, 404);
            ctx.lineTo(765, 409);
            ctx.fill();
            ctx.closePath();

            ctx.beginPath();//blue line
            ctx.strokeStyle = "blue";
            ctx.moveTo(53, 342);
            ctx.lineTo(53, 413);
            ctx.lineTo(100, 413);
            ctx.stroke();
            ctx.moveTo(100, 397);
            ctx.lineTo(100, 434);
            ctx.lineTo(162, 434);
            ctx.lineTo(162, 397);
            ctx.stroke();
            ctx.moveTo(162, 413);
            ctx.lineTo(209, 413);
            ctx.lineTo(209, 342);
            ctx.stroke();
            ctx.moveTo(131, 434);
            ctx.lineTo(131, 522);
            ctx.lineTo(266, 522);
            ctx.lineTo(266, 514);
            ctx.stroke();
            ctx.moveTo(266, 410);
            ctx.lineTo(266, 278);
            ctx.stroke();
            ctx.moveTo(266, 287);
            ctx.lineTo(458, 287);
            ctx.lineTo(458, 342);
            ctx.stroke();
            ctx.moveTo(266, 250);
            ctx.lineTo(266, 262);
            ctx.stroke();
            ctx.moveTo(458, 358);
            ctx.lineTo(458, 384);
            ctx.stroke();
            ctx.moveTo(458, 287);
            ctx.lineTo(556, 287);
            ctx.lineTo(583, 265);
            ctx.stroke();
            ctx.moveTo(556, 287);
            ctx.lineTo(583, 309);
            ctx.stroke();
            ctx.moveTo(623, 265);
            ctx.lineTo(650, 287);
            ctx.stroke();
            ctx.moveTo(623, 309);
            ctx.lineTo(650, 287);
            ctx.stroke();
            ctx.moveTo(650, 287);
            ctx.lineTo(703, 287);
            ctx.stroke();
            ctx.moveTo(689, 287);
            ctx.lineTo(689, 299);
            ctx.stroke();
            ctx.moveTo(689, 321);
            ctx.lineTo(689, 332);
            ctx.stroke();
            ctx.moveTo(723, 287);
            ctx.lineTo(800, 287);
            ctx.stroke();
            ctx.moveTo(325, 514);
            ctx.lineTo(325, 522);
            ctx.lineTo(493, 522);
            ctx.stroke();
            ctx.moveTo(444, 522);
            ctx.lineTo(444, 540);
            ctx.stroke();
            ctx.moveTo(444, 562);
            ctx.lineTo(444, 573);
            ctx.stroke();
            ctx.moveTo(499, 491);
            ctx.lineTo(493, 491);
            ctx.lineTo(493, 553);
            ctx.lineTo(499, 553);
            ctx.stroke();
            ctx.moveTo(515, 491);
            ctx.lineTo(524, 491);
            ctx.stroke();
            ctx.moveTo(515, 553);
            ctx.lineTo(524, 553);
            ctx.stroke();
            ctx.moveTo(564, 491);
            ctx.lineTo(578, 491);
            ctx.lineTo(578, 553);
            ctx.lineTo(564, 553);
            ctx.stroke();
            ctx.moveTo(578, 522);
            ctx.lineTo(703, 522);
            ctx.stroke();
            ctx.moveTo(723, 522);
            ctx.lineTo(851, 522);
            ctx.lineTo(851, 245);
            ctx.lineTo(900, 245);
            ctx.stroke();
            ctx.moveTo(920, 245);
            ctx.lineTo(951, 245);
            ctx.stroke();
            ctx.closePath();

            ctx.fillStyle = "blue";
            ctx.beginPath();
            ctx.moveTo(131, 487);
            ctx.lineTo(126, 495);
            ctx.lineTo(136, 495);
            ctx.lineTo(131, 487);
            ctx.fill();
            ctx.moveTo(350, 522);
            ctx.lineTo(358, 527);
            ctx.lineTo(358, 517);
            ctx.lineTo(350, 522);
            ctx.fill();
            ctx.moveTo(820, 522);
            ctx.lineTo(828, 527);
            ctx.lineTo(828, 517);
            ctx.lineTo(820, 522);
            ctx.fill();
            ctx.moveTo(765, 287);
            ctx.lineTo(773, 292);
            ctx.lineTo(773, 282);
            ctx.lineTo(765, 287);
            ctx.fill();
            ctx.closePath();

            /////////////////////////////


        }
    };

    render() {
        return (
            <canvas className='cvs' id={this.props.canvas_id} width="1100" height="750"/>
        );
    }
}

TeploAll.propTypes = {
    canvas_id: React.PropTypes.string,
};


// WEBPACK FOOTER //
// ./src/components/entries/TeploAll/index.jsx